import React from 'react';
import { getStatusConfig, getPaymentStatusConfig } from '../utils/documentStatuses';

/**
 * StatusBadge Component
 * Displays a color-coded badge for document or payment status
 */
const StatusBadge = ({ 
  status, 
  documentType, 
  isPaymentStatus = false,
  className = ''
}) => {
  if (!status) {
    return null;
  }

  // Get the appropriate configuration
  const config = isPaymentStatus 
    ? getPaymentStatusConfig(status)
    : getStatusConfig(status, documentType);

  return (
    <span 
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color} ${className}`}
      title={config.label}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
